export const getOrderRefundList = state => state.ordersRefunded.numbers.map(number => state.orders[number]);


export const getUnreadRefundOrdersMessages = state => state.ordersRefunded.unreadOrderMessages > 0;
